/**
 * GridToolbarSection Component
 * Story 6.1: Implement Unified Toolbar Wrapper
 *
 * AC-6.1.3: Contextual icons for Grid/Sheet tab
 * Shows: Data, Filter, Sort, Group icons
 */
import { Search, Filter, ArrowUpDown, Rows3 } from 'lucide-react';
import { ToolbarButton } from './ToolbarButton';

interface GridToolbarSectionProps {
  /** Callback when data/search is triggered */
  onData?: () => void;
  /** Callback when filter is triggered */
  onFilter?: () => void;
  /** Callback when sort is triggered */
  onSort?: () => void;
  /** Callback when group is triggered */
  onGroup?: () => void;
  /** Whether filter is active */
  filterActive?: boolean;
  /** Whether grouping is active */
  groupActive?: boolean;
}

/**
 * GridToolbarSection - Contextual toolbar icons for Grid/Sheet tab
 *
 * Icons: Data (search), Filter, Sort, Group
 */
export function GridToolbarSection({
  onData,
  onFilter,
  onSort,
  onGroup,
  filterActive = false,
  groupActive = false,
}: GridToolbarSectionProps) {
  return (
    <div
      role="group"
      aria-label="Grid tools"
      className="toolbar-group"
    >
      <ToolbarButton
        icon={<Search className="w-5 h-5" />}
        label="Data"
        shortcut="Mod+Shift+F"
        onClick={onData}
      />
      <ToolbarButton
        icon={<Filter className="w-5 h-5" />}
        label="Filter"
        active={filterActive}
        onClick={onFilter}
      />
      <ToolbarButton
        icon={<ArrowUpDown className="w-5 h-5" />}
        label="Sort"
        onClick={onSort}
      />
      <ToolbarButton
        icon={<Rows3 className="w-5 h-5" />}
        label="Group"
        active={groupActive}
        onClick={onGroup}
      />
    </div>
  );
}
